class ElabellCardPurchase extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.addEventListener('change', event => {
      if (!event.target.matches('[data-eb-variant]')) return;
      const form = event.target.closest('form');
      const selected = event.target.selectedOptions[0];
      form.querySelector('input[name="id"]').value = event.target.value;
      const min = Number(selected.dataset.min) || 1;
      form.querySelector('input[name="quantity"]').value = String(min);
      this.querySelector('product-form-component').dataset.quantityDefault = String(min);
    });
  }
}
if (!customElements.get('elabell-card-purchase')) customElements.define('elabell-card-purchase', ElabellCardPurchase);

function updateElabellVariantPhoto(select) {
  const option = select.selectedOptions[0];
  if (!option?.value) return;
  const card = select.closest('.eb-unified-extra, .eb-cart-suggestion, product-card');
  if (!card) return;
  const gallery = card.querySelector('.card-gallery');
  const image = card.querySelector('.eb-unified-photo img, .eb-cart-suggestion-image img, .card-gallery .product-media__image');
  if (image && option.dataset.image) {
    image.srcset = option.dataset.imageSmall && option.dataset.imageLarge
      ? option.dataset.imageSmall + ' 400w, ' + option.dataset.image + ' 800w, ' + option.dataset.imageLarge + ' 1200w'
      : option.dataset.image + ' 240w';
    image.src = option.dataset.image;
    image.alt = option.dataset.imageAlt || '';
    image.sizes = gallery ? '(min-width: 1100px) 25vw, (min-width: 750px) 33vw, 50vw' : '76px';
    const slideshow = gallery?.querySelector('slideshow-component');
    if (slideshow?.select) slideshow.select(0, undefined, { animate: false });
    const addButton = card.querySelector('add-to-cart-component');
    if (addButton) addButton.dataset.productVariantMedia = option.dataset.image;
    if (card.matches('product-card')) card.dataset.featuredMediaUrl = option.dataset.image;
  }
  if (option.dataset.productUrl) {
    card.querySelectorAll('.eb-unified-photo, .eb-unified-extra-title, .eb-cart-suggestion-image, .eb-cart-suggestion-info > a, .product-card__link, [ref="cardGalleryLink"]').forEach(link => link.href = option.dataset.productUrl);
  }
}
document.addEventListener('change', event => {
  if (event.target instanceof HTMLSelectElement && event.target.matches('[data-eb-variant], [data-eb-extra-variant]')) {
    updateElabellVariantPhoto(event.target);
  }
});
